<template>
  <div class="news-page">
    <SideBar 
      :groups="groups" 
      :isSidebarOpen="isSidebarOpen"
      @toggle-sidebar="toggleSidebar"
      @close-sidebar="closeSidebar"
      @handle-logout="handleLogout"
    />
    <div class="main-content">
      <TopBar 
        :source="tag"
        @toggle-sidebar="toggleSidebar"
        @selected="getSelected"      />
      <div class="content-area">
        <Breadcrumb :items="[
          { text: 'Dashboard', link: '/dashboard' },
          { text: 'News & Updates' }
        ]" />
        
        <SectionContainer>
          <SectionHeader title="News & Updates" />
          
          <div class="news-filter">
            <div class="search-container">
              <input 
                type="text" 
                v-model="searchQuery" 
                placeholder="Search news..." 
                class="search-input"
              />
              <i class="material-icons search-icon">search</i>
            </div>
          </div>
          
          <div v-if="isLoading" class="loading-container">
            <LoadingSpinner size="medium" color="blue" />
          </div>
          
          <div v-else-if="filteredNews.length === 0" class="no-results">
            <i class="material-icons">info</i>
            <p>No news items found.</p>
          </div>
          
          <div v-else class="news-grid">
            <NewsCard 
              v-for="item in filteredNews" 
              :key="item.NewsID" 
              :newsItem="item"
            />
          </div>
        </SectionContainer>
      </div>
      
      <AppFooter />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import config from "../config.js";
import SideBar from "./SideBar.vue";
import TopBar from "./TopBar.vue";
import AppFooter from "./AppFooter.vue";
import NewsCard from "./NewsCard.vue";
import SectionHeader from "./SectionHeader.vue";
import SectionContainer from "./SectionContainer.vue";
import Breadcrumb from "./Breadcrumb.vue";
import LoadingSpinner from "./LoadingSpinner.vue";
import "../assets/css/dashboard.css";

export default {
  name: "NewsPage",
  components: {
    SideBar,
    TopBar,
    AppFooter,
    NewsCard,
    SectionHeader,
    SectionContainer,
    Breadcrumb,
    LoadingSpinner
  },
  data() {
    return {
      news: [],
      groups: [],
      user: [],
      tag: [],
      isLoading: true,
      searchQuery: "",
      isSidebarOpen: false,
      usercookie: $cookies.get("arch-it-portal"),
    };
  },
  computed: {
    filteredNews() {
      if (!this.searchQuery) {
        return this.news;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.news.filter(item => 
        item.NewsTitle.toLowerCase().includes(query) || 
        item.NewsShort.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    getToken() {
      return this.$cookies.get("arch-it-portal") || this.usercookie;
    },    getNews() {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("news/12"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => {
          this.news = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching news:", error);
          this.isLoading = false;
        });
    },
    getGroups() {      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("group"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.groups = response.data));
    },    getTag() {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("get-tag"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.tag = response.data));
    },    getUser() {
      let params = new URLSearchParams();
      params.append("user", this.usercookie);
      const token = this.getToken();
      
      axios({
        method: "post",
        url: config.getApiUrl("get-user"),
        data: params,
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      })
        .then((response) => {
          this.loginStatus(response.data);
        });
    },
    loginStatus(userData) {
      if (
        !userData ||
        !userData.expire ||
        Number(userData.expire) < Math.floor(Date.now() / 1000)
      ) {
        router.push({
          name: "Login",
        });
      }
    },
    handleLogout() {
      $cookies.remove("arch-it-portal");
      router.push({
        name: "Login",
      });
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      document.body.style.overflow = this.isSidebarOpen ? "hidden" : "";
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.body.style.overflow = "";
    },
    getSelected(result) {
      window.open(result.value, "_blank");
    },
    handleResize() {
      if (window.innerWidth > 768 && this.isSidebarOpen) {
        this.closeSidebar();
      }
    }
  },
  created() {
    this.getUser();
    this.getGroups();
    this.getTag();
    this.getNews();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
.news-page {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.news-filter {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.search-container {
  position: relative;
  width: 300px;
}

.search-input {
  width: 100%;
  padding: 10px 40px 10px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.search-input:focus {
  border-color: #1565c0;
  box-shadow: 0 2px 5px rgba(21, 101, 192, 0.15);
  outline: none;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #757575;
  font-size: 20px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 30px;
}

.no-results {
  text-align: center;
  padding: 30px;
  color: #757575;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-results i {
  font-size: 48px;
  margin-bottom: 15px;
  color: #bbdefb;
}

@media (max-width: 992px) {
  .news-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  
  .search-container {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .news-grid {
    grid-template-columns: 1fr;
  }
  
  .news-filter {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsPage.vue